/**
 * A simple component to tell the user that a collection is empty.
 */
export default {
  title: 'Atoms/Empty',
  tags: ['autodocs'],
  render: () => `<sharpen-empty>You have no active subscriptions.</sharpen-empty>`,
};

export const Example = {};
